export default "<div class=\"dc-sidebar\">\r\n    <dc-list :locale=\"locale\"></dc-list>\r\n</div>";